import { render } from "./FulijiPage.vue?vue&type=template&id=5420e257&scoped=true"
import script from "./FulijiPage.vue?vue&type=script&lang=js"
export * from "./FulijiPage.vue?vue&type=script&lang=js"

import "./FulijiPage.vue?vue&type=style&index=0&id=5420e257&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5420e257"]])

export default __exports__